import { get, put, post, patch, delet, del, delte } from '@core/request';

export * from './sign';

// 上传文件
export const fileApi = (params, option) => {
    return post('/conference/file', params, option);
};

//会议列表
export const conferenceSaveApi = params => {
    return post('/conference/boss/conferences/save', params);
};

export const conferenceListApi = params => {
    return post('/conference/boss/conferences/list', params);
};

// 更新会议的聚合列表状态、健康界平台状态
// conferenceId
// hidden 是否隐藏：0不隐藏，1隐藏
// healthcarePlatformHidden 健康界平台是否隐藏：0显示，1隐藏
export const conferencetHiddenStateApi = params => {
    return patch('/conference/boss/conferences/setHiddenState', params);
};

// 标记为测试会议
export const conferenceMarkAsTesting = data => put('/conference/boss/conferences/markAsTesting', data);

// 删除会议
export const conferenceDelApi = params => {
    return get('/conference/boss/conferences/delete', params);
};

// 获取会议详情
export const conferenceOnceApi = params => {
    return get('/conference/boss/conferences/getOneById', params);
};

// 更新会议
export const conferenceUpdateApi = params => {
    return put('/conference/boss/conferences/update', params);
};

// 更新会议会场规划图
export const conferenceUpdateHallPlanImagesApi = params => {
    return put('/conference/boss/conferences/update-hall-plan-images', params);
};

//直播列表
export const getConferenceLivesListApi = params => {
    return get('/conference/boss/lives/list', params);
};

// 获取直播详情
export const getLiveOneByIdApi = params => {
    return get('/conference/boss/lives/getOneById', params);
};

// 获取直播评论列表
export const getConferenceLiveCommentsListApi = params => {
    return get('/conference/boss/livecomments/list', params);
};

// 删除直播评论
export const deleteConferenceLiveCommentIdApi = params => {
    return get('/conference/boss/livecomments/delete', params);
};

// 保存直播评论
export const saveLiveCommentApi = params => {
    return post('/conference/boss/livecomments/save', params);
};

// 获取会议厅列表
export const liveConferencehallsApi = params => {
    return get('/conference/boss/conferencehalls/firstList', params);
};

/**
 * 调整会议日期
 * @param {Object} data
 * @param {number} data.hallId 会议ID
 * @param {string} data.date 会议日期
 * @param {number} [data.pid] 所属会议ID（上级会议ID）
 * @returns
 */
export const changeConferenceHallDateApi = data => put('/conference/boss/conferencehalls/changeDate', data);

// 保存直播
export const saveLiveApi = params => {
    return post('/conference/boss/lives/save', params);
};

// 获取直播详情
export const getLiveInfoApi = params => {
    return get('/conference/boss/lives/getOneById', params);
};

// 删除直播
export const delLiveOnceApi = params => {
    return get('/conference/boss/lives/delete', params);
};

// 编辑直播
export const editLiveApi = params => {
    return put('/conference/boss/lives/update', params);
};

// 设置直播类型
export const liveSettingApi = params => {
    return put('/conference/boss/lives/changeType', params);
};

// 添加白名单
export const addWhitListsApi = params => {
    return post('/conference/boss/livewhitelist/save', params);
};

// 获取白名单列表
export const getWhitListsApi = params => {
    return get('/conference/boss/livewhitelist/list', params);
};

// 删除白名单
export const delWhitListsApi = params => {
    return post('/conference/boss/livewhitelist/delete', params);
};

// 获取推拉流地址
export const getPullUrlApi = params => {
    return get('/conference/boss/liveReplays/getPullUrl', params);
};

//视频上传
//获取阿里云上传凭证
export const getAliyuncred = data => {
    return post('/conference/boss/liveReplays/upload-info', data, { timeout: 600000 });
};

//阿里云OSS刷新凭证
export const refreshAliyuncred = data => {
    return get('/conference/boss/liveReplays/re-upload-info', data);
};

// 保存直播回放
export const upLoadVideoApi = data => {
    return post('/conference/boss/liveReplays/saveLiveReplay', data, { timeout: 600000 });
};

// 获取回放直播列表
export const liveReplaysListApi = data => {
    return get('/conference/boss/liveReplays/list', data);
};

//删除直播回放
export const delVideoApi = data => {
    return post('/conference/boss/liveReplays/deleteLive', data, { timeout: 600000 });
};

// 获取回放直播列表
export const fetchReplayVideoList = params => get('/conference/boss/liveReplays/replays-mp4', params);

//设为默认
export const defaultVideoApi = data => {
    return post('/conference/boss/liveReplays/defaultPlay', data, { timeout: 600000 });
};

// 医会议数据看板
export const listConferenceUsage = params => get('/conference/boss/conf-usage/list-data-total', params);

// 医会议数据看板数据导出
export const exportConferenceUsage = params => get('/conference/boss/conf-usage/list-data-total/download', params, { responseType: 'blob' });

//获取上传凭证
export const getVideoUrlApi = data => {
    return get('/conference/boss/liveReplays/getVideoUrl', data);
};

//获取上传凭证
export const updateLiveStartTimeApi = data => {
    return put('/conference/boss/liveReplays/updateLiveStartTime', data);
};

/**
 * @description: 获取随机评论数量
 * @return {Promise<any>}
 */
export const getFakeCommentCount = () => get('/conference/user/lives/getFakeCommentCount');

/**
 * @description: 发送随机评论
 * @return {Promise<any>}
 */
export const sendFakeComments = params => post('/conference/user/lives/sendFakeComments', params);

// 修改嘉宾身份
export const batchUpdateRoleApi = data => {
    return post('/conference/boss/guests/batchUpdateRole', data);
};
// 批量修改嘉宾身份
export const batchUpdateHiddenApi = data => {
    return put('/conference/boss/guests/batchUpdateHidden', data);
};

/**
 * 删除会议相关缓存
 * @param data
 * @returns {boolean}
 *
 * {type: '', key: ''}
 *
 * type 缓存类型
 * key 缓存键值
 *
 * type: conference, agendas, live, guests 限制在这个范围，不是这些取值时， 400 缓存类型不存在，清除缓存失败！
 *
 * key:
 * conference_<conferenceId>_site_modules
 * conference_<conferenceId>_user_agendas
 * conference_<conferenceId>_user_live_<liveId>
 * conference_<conferenceId>_user_guests
 */
export const deleteConferenceCache = data => delet('/conference/boss/conferences/cache', data);

// 更新嘉宾显示类型
export const updateGuestsShowTypeApi = data => put('/conference/boss/conferences/update-guests-show-type', data);

/**
 * 获取会议权益列表
 * @param {Object} params
 * @param {number} params.conferenceId 会议ID
 * @returns {Promise<{status_code: number, data: Array}>}
 */
export const getConferenceBenefitList = params => get('/conference/boss/conferenceBenefit/list', params);

// 获取赞助企业列表
export const sponsorList = params => post('/conference/boss/sponsor/list', params);

// 获取赞助企业筛选项
export const getSponsorFilterOptions = params => get('/conference/boss/sponsor/filterOptions', params);

// 根据ID获取赞助企业信息
export const getSponsor = params => get(`/conference/boss/sponsor/info/${params}`);

// 增加赞助企业
export const saveSponsor = params => post('/conference/boss/sponsor/save', params);

// 更新赞助企业
export const updateSponsor = params => put('/conference/boss/sponsor/update', params);

// 删除赞助企业
export const delSponsor = params => post('/conference/boss/sponsor/delete', params);

// 排序赞助企业
export const sortSponsor = params => get('/conference/boss/sponsor/sort', params);

// 机构权益兑现
export const deliverBenefit = params => post('/conference/boss/sponsor/deliverBenefit', params);

// 获取会议已分配权益列表
export const conferenceBenefitList = params => get('/conference/boss/conferenceBenefit/list', params);

// 删除会议权益
export const deleteConferenceBenefit = params => post('/conference/boss/conferenceBenefit/delete', params);

// 更新会议权益
export const updateConferenceBenefit = params => put('/conference/boss/conferenceBenefit/update', params);

// 批量分配会议权益
export const batchSaveConferenceBenefit = params => post('/conference/boss/conferenceBenefit/batchSave', params);

// 获取项目所有权益列表
export const listAllSponsorBenefits = params => get('/conference/boss/sponsorBenefits/listAll', params);

// 新增项目权益
export const saveSponsorBenefit = params => post('/conference/boss/sponsorBenefits/save', params);

// 更新项目权益
export const updateSponsorBenefit = params => put('/conference/boss/sponsorBenefits/update', params);

// 删除项目权益
export const deleteSponsorBenefit = params => post('/conference/boss/sponsorBenefits/delete', params);

// 根据大会ID查询二级子会议
export const hallList = params => get('/conference/boss/conferencehalls/getHallList', params);

// 根据大会ID查询会议详情
export const hallsDetails = params => get('/conference/boss/conferencehalls/getOneById', params);

// 获取会议专家排序列表
export const getHallExpertSorts = params => get('/conference/boss/conferencehalls/getHallExpertSorts', params);

// 获取上传数据的参数
export const conferenceOssData = params => get('/dataengine/api/oss/conference/uploadSignature');

// 劳务审批流程
export const laborAuditFlowsApi = params => get('/conference/boss/conferences/auditFlows', params);

// 预约数据
export const liveReservationsApi = params => get('/conference/livereservations/page', params);

// 预约数据导出
export const liveReservationsExportApi = params => get('/conference/livereservations/download', params, { responseType: 'blob' });

// 报名数据
export const liveSignUpApi = params => get('/conference/activityregistragtionusers/page', params);

// 预约数据导出
export const liveSignUpExportApi = params => get('/conference/activityregistragtionusers/download', params, { responseType: 'blob' });

// 预约数据 - 题目配置列表
export const getLiveQuestionListApi = params => get('/conference/activityregistragtionusers/listByLiveId', params);

// 项目劳务进度
export const laborProgressApi = params => get('/conference/boss/conferences/labor-progress-page', params);

// 导出项目劳务进度
export const exportLaborProgressApi = params => get('/conference/boss/conferences/labor-progress-download', params, { responseType: 'blob' });

// 会议项目设置劳务需求备注
export const setLaborFeeDemandRemarkApi = data => put('/conference/boss/laborFee/demand-remarks', data);

/**
 * 修改会议项目是否需要劳务费付款
 * labelPayment 0无需劳务，1需要劳务
 * @param data data: { id: 1, labelPayment: 1 }
 * @returns {*}
 */
export const changeLaborFeePaymentStatus = data => put('/conference/boss/conferences/updateLabelPayment', data);

// 专家综评列表
export const getConferenceEvaluationListApi = params => get('/conference/boss/conferencehalls/list-conference-evaluations', params);

// 查询专家和日程信息
export const getExpertAndAgendaInfoApi = params => get('/conference/boss/conferencehalls/getExpertAndAgendaInfo', params);
